/* eslint-env browser */
import _ from 'lodash';
import React from 'react';
import { Box } from 'reflexbox';
import { Input } from 'rebass';

import CopyToClipboard from 'frontend/components/CopyToClipboard';

const ShareReport = () => {
  const url = _.get(window, 'location.href', '');
  return (
    <Box>
      <Input
        label="Share Report URL"
        name="reportUrl"
        disabled
        value={url}
        mb={0}
      />
      <CopyToClipboard value={url} />
    </Box>
  );
};

export default ShareReport;
